class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector('.product-information product-form-component');
    this.sellingPlanSelect = this.querySelector('.sticky-product__selling_plan-select') || null;
    this.sellingPlanInput = document.querySelectorAll('.product-subscription__select .selling-plan') || null;
    this.sellingPlanProductData = this.querySelector('.sticky-product-subscription__select input');
    if (this.sellingPlanInput && this.sellingPlanSelect) {
      this.sellingPlanSelect.addEventListener('change', this.changeSellingPlan.bind(this));
    }

  }

  changeSellingPlan() {
    if (this.sellingPlanInput && this.sellingPlanSelect) {
      this.sellingPlanInput.value = this.sellingPlanSelect.value;
      const button = this.querySelector('.add-to-cart-text__content');
      if (button) {
        const prefix = button?.innerText.split('$')[0];
        const originPrice = this.sellingPlanProductData?.dataset.originPrice;
        const price = this.sellingPlanProductData?.dataset.price;
        this.sellingPlanInput.value != '' ? button.innerText = prefix + price : button.innerText = prefix + originPrice;
      }
    }
  }

  connectedCallback() {
    if (!this.form) return;

    const formBottom = () => {
      const rect = this.form.getBoundingClientRect();
      return rect.bottom + window.scrollY;
    };

    const handleScroll = () => {
        this.toggleAttribute('hidden', window.scrollY < formBottom());
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}